<page-content *ngIf="!!myOrganisations">

  <mat-form-field *ngIf="myOrganisations.length > 1">
    <input #searchField (ngModelChange)="filterOrganisations(currentSearchTerm)" [(ngModel)]="currentSearchTerm" matInput
           placeholder="Search"/>
  </mat-form-field>

  <div *ngIf="!!filteredOrganisations" class="card-container">

    <div *ngFor="let tag of organisationTags" [class.static]="!(tag !== 'static' && sortedOrganisations[tag].length > 6)" class="group">
      <ng-container *ngIf="sortedOrganisations[tag] && sortedOrganisations[tag].length">

        <mat-expansion-panel *ngIf="tag !== 'static' && sortedOrganisations[tag].length > 6; else destinationCards">
          <mat-expansion-panel-header>
            <mat-panel-title>{{'organisation.tag.' + tag | translate}} ({{sortedOrganisations[tag].length}})</mat-panel-title>
          </mat-expansion-panel-header>
          <mat-card appearance="outlined" (click)="selectOrganisation(organisation)" *ngFor="let organisation of sortedOrganisations[tag]" class="org">
            <mat-card-header>
              <mat-card-title>{{organisation.title}}</mat-card-title>
            </mat-card-header>
          </mat-card>
        </mat-expansion-panel>
        <ng-template #destinationCards>
          <mat-card appearance="outlined" (click)="selectOrganisation(organisation)" *ngFor="let organisation of sortedOrganisations[tag]" class="org">
            <mat-card-header>
              <mat-card-title>{{organisation.title}}</mat-card-title>
            </mat-card-header>
          </mat-card>
        </ng-template>
      </ng-container>
    </div>
  </div>


  <div *ngIf="!filteredOrganisations || !filteredOrganisations.length">
    <p>{{'organisation.noResult' | translate}}</p>
  </div>

</page-content>

<page-content *ngIf="!myOrganisations">

  <h2>{{'organisation.noOrgTitle' | translate}}</h2>

  <div>
    <p>{{'organisation.noOrgMessage' | translate}}</p>
    <a [href]="'mailto:' + supportMail" mat-raised-button>{{'organisation.sendMail' | translate}}</a>
  </div>

</page-content>
